<script setup>
import { } from 'vue';

// Removed landingImages and thumbnail computed; each project's img now points to its landing.* asset.
const props = defineProps({ project: { type: Object, required: true } });

const backgroundColor = {
  scripto: '#2544B8',
  beezy: '#fff000',
  arkivia: '#1E1F22',
  insectus: '#F9F9F9'
};

const bg = backgroundColor[props.project.slug] || '#FFFFFF';
</script>

<template>
  <router-link
      :to="{ name: 'Project Detail', params: { slug: props.project.slug } }"
      class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark"
      aria-label="Single Project"
  >
    <div
        class="w-full h-56 flex items-center justify-center rounded-t-xl overflow-hidden p-3"
        :style="{ backgroundColor: bg }"
    >
      <img
          :src="props.project.img"
          :alt="props.project.title + ' thumbnail'"
          class="max-h-full max-w-full object-contain"
      />
    </div>
    <div class="text-center px-4 py-6">
      <p class="font-general-semibold text-xl text-ternary-dark dark:text-ternary-light font-semibold mb-2">
        {{ props.project.title }}
      </p>
      <span class="font-general-medium text-lg text-ternary-dark dark:text-ternary-light">{{ props.project.category }}</span>
    </div>
  </router-link>
</template>

<style lang="scss" scoped></style>
